import LinkBase, { type LinkBaseProps } from '../link-base';
import classes from './index.module.scss';

export interface LinkMessageProps extends LinkBaseProps {
  onOpen?: (url: string) => boolean | void;
}

export default function LinkMessage({ className, onOpen, ...props }: LinkMessageProps) {
  return (
    <LinkBase
      className={cls(classes.linkMessage, className)}
      onClick={(e) => {
        const href = e.currentTarget.href;
        e.preventDefault();
        e.stopPropagation();
        onOpen?.(href);
      }}
      {...props}
    ></LinkBase>
  );
}
